/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useContext } from 'react';
import { QueryProvider, QueryContext } from '@thd-nucleus/data-sources';

const ssr = typeof window === 'undefined';

let EmtLinksImport;

/** *********************
 * Emt Links
 ********************** */
export const EmtLinksLoad = () => import(
  /* webpackChunkName: "emt-links" */
  '@thd-olt-component-react/emt-links')
  .then((module) => {
    const { EmtLinks } = module;

    EmtLinksImport = (props) => {
      const value = useContext(QueryContext);
      return (
        <QueryProvider defaultVariables={value.defaultVariables.current} cacheKey="emt-links-import">
          <EmtLinks {...props} />
        </QueryProvider>
      );
    };
  });

export const EmtLinks = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/emt-links')).EmtLinks
  : (props) => <EmtLinksImport {...props} />;

export const EmtLinksModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/emt-links')).EmtLinks.dataModel
  : {};
